import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PymesComponent } from '../../components/pymes/pymes.component';

@Component({
	selector: 'app-pymes-salud',
	standalone: true,
	imports: [CommonModule, PymesComponent],
	templateUrl: './pymes-salud.component.html',
	styleUrls: ['./pymes-salud.component.scss']
})
export class PymesSaludComponent {}
